export enum RoleActionType {
    ROLES_FETCHED = "ROLES_FETCHED",
}
